module.exports = __webpack_public_path__ + "shanz/static/media/Women accessories.3fa8a6cd.png";